import * as Raven from 'raven-js';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { CustomFormsModule } from 'ng2-validation';
//import { NgxAutoScroll } from "ngx-auto-scroll/lib/ngx-auto-scroll.directive";

import { ApiService }     from './services/api.service';
import { AuthGuard }     from './services/authguard.service';
import { AntiAuthGuard }     from './services/anti-authguard.service';

import { RouterModule, PreloadAllModules } from '@angular/router';
import { ROUTES } from './app.routes';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { CheckinComponent } from './checkin/checkin.component';
import { SignupComponent } from './signup/signup.component';
import { VisitorsComponent } from './visitors/visitors.component';

Raven
  .config('https://8618fc232a22497eab187cc08fe62bb8@sentry.io/207387')
  .install();

export class RavenErrorHandler implements ErrorHandler {
  handleError(err:any) : void {
    Raven.captureException(err);
  }
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    CheckinComponent,
    SignupComponent,
    VisitorsComponent

  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    BrowserAnimationsModule,
    CustomFormsModule,
    //NgxAutoScroll,
    RouterModule.forRoot(ROUTES, { useHash: false, preloadingStrategy: PreloadAllModules })

  ],
  providers: [
    { provide: ErrorHandler, useClass: RavenErrorHandler },
    ApiService,
    AuthGuard,
    AntiAuthGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts